import { render } from "./CustomTextarea.vue?vue&type=template&id=0d17e957&scoped=true&ts=true"
import script from "./CustomTextarea.vue?vue&type=script&lang=ts"
export * from "./CustomTextarea.vue?vue&type=script&lang=ts"

import "./CustomTextarea.vue?vue&type=style&index=0&id=0d17e957&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d17e957"]])

export default __exports__